import React from "react";
import { Link } from "react-router-dom";

export const Complaints = () => {
  return (
    <div className="mb-5 pb-5">
      <section className="container mt-3">
        <div className="d-flex justify-content-between align-items-start">
          <p className="p">Bem-vindos ao Canal de Denúncias 1RIGO</p>
          <a className="btn btn-outline-warning" href="./">
            Voltar
          </a>
        </div>

        <p>
          Para realizar um relato, por favor, escolha uma das opções abaixo:
        </p>
      </section>
      <section className="container denuncias-index">
        <div>
          <Link to="/relationship">
            <i className="bi bi-chat-right-quote"></i>
            <p>Denúncias sobre Relacionamentos</p>
          </Link>
        </div>
        <div>
          <Link to="/fraudes">
            <i className="bi bi-chat-right-quote"></i>
            <p>Denúncias sobre Fraudes, Corrupção, Atividades ilícitas</p>
          </Link>
        </div>
        <div>
          <Link to="/add-complaint/riscos-operacionais/">
            <i className="bi bi-chat-right-quote"></i>
            <p>Denúncias sobre Saúde e Segurança Ocupacional</p>
          </Link>
        </div>
      </section>
    </div>
  );
};
